import { render, staticRenderFns } from "./PPOBReport.vue?vue&type=template&id=495f683c"
import script from "./PPOBReport.vue?vue&type=script&lang=js"
export * from "./PPOBReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports